module.exports = __webpack_public_path__ + "static/media/ic_db_help.abbf9976.svg";